import GPTRADE_EXT_1 from "./GPTRADE_EXT_1";

export default {
  GPTRADE_EXT_1,
};
